<h1 mat-dialog-title>{{'executionEdit.referenceDocs.title' | translate}}</h1>

<div mat-dialog-content class="thermal-theme">

  <div fxLayout="row" fxLayout.xs="column" class="flexwrap">
    <div fxFlex="100">
      <mat-form-field class="campoFormulario">
        <mat-label>{{ 'protocolEdit.referenceDocs.procedure.label' | translate }}</mat-label>
        <mat-select name="procedures" (selectionChange)="onSelectProcedure($event)">
          @for (item of procedures; track item) {
            <mat-option [value]="item.id">
              {{item.name}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <div fxFlex="100">
      <mat-form-field class="campoFormulario">
        <mat-label>{{ 'executionEdit.referenceDocs.code.label' | translate }}</mat-label>
        <input matInput [(ngModel)]="data.refDoc.code" required [disabled]="data.disabled"
          [ngModelOptions]="{standalone: true}">
        <mat-error>
          {{ 'executionEdit.referenceDocs.code.error' | translate }}
        </mat-error>
      </mat-form-field>
    </div>
    <div fxFlex>
      <mat-form-field class="campoFormulario">
        <mat-label>{{ 'executionEdit.referenceDocs.name.label' | translate }}</mat-label>
        <input matInput [(ngModel)]="data.refDoc.name" [disabled]="data.disabled" [ngModelOptions]="{standalone: true}">
      </mat-form-field>
    </div>
  </div>

</div>

<div mat-dialog-actions align="end" class="getTheme()">
  @if (!data.disabled) {
    <button mat-raised-button color="primary" (click)="onOkClick()">
    {{ 'button.save' | translate }}</button>
  }
  <button mat-raised-button color="secondary" (click)="onNoClick()">
  {{ 'button.cancel' | translate }}</button>
</div>